var ContactFormJs = (function ($) {
    var orderNumberRegex = "^[0-9]{3,}$";
    var specialCharactersRegex = "[<>=;/]+";
    var maxOrderNumberInputs = 10;
    var orderNumberInputCounter = 1;

    function sendDataToChatMondo() {
        return new Promise((resolve, reject) => {
            const sendMessageToMondo = (email, message, callback) => {
                if (checkIfMondoIsLoaded()) {
                    const sendMessage = () => {
                        setTimeout(() => {
                            const response = MDN.webchat.user.sendMessage(message);

                            if (response && response.success) {
                                console.log("Message sent");
                                MDN.Event.unsubscribe("onAuthenticated");
                                MDN.Event.unsubscribe("webIframeLoaded");
                                MDN.Event.unsubscribe("webChatShow");
                                MDN.Event.unsubscribe("onDisconnected");
                                callback({ success: true, reason: "Message sent" });
                            } else {
                                console.log("Message sent failure");
                                callback({ success: false, reason: "Message sent failure" });
                            }
                        }, 1000);
                    };

                    MDN.Event.subscribe("webIframeLoaded", () => {
                        console.log("received event, iframe was loaded, authenticate and sent message");
                        authenticateAndSendMessage();
                    });

                    MDN.Event.subscribe("webChatShow", () => {
                        console.log("received event, widget was opened, start send message");
                        sendMessage();
                    });

                    const authenticateAndSendMessage = () => {
                        MDN.Event.subscribe("onAuthenticated", () => {
                            console.log("receive event, agent was authenticated, open widget");
                            setTimeout(() => {
                                MDN.webchat.openWidget();
                            }, 1000);
                        });

                        console.log("Start authenticate user email: ", email);
                        const response = MDN.webchat.user.authenticate(email); // {success: true/false}
                        if (response && !response.success && response.code === 102) {
                            console.log("The user already authenticated, we will disconnect user and authenticate with new email address: ", email);
                            MDN.webchat.user.disconnectUser();
                        }
                    };

                    MDN.Event.subscribe("onDisconnected", () => {
                        console.log("Received event, user was disconnected");
                        authenticateAndSendMessage();
                    });

                    if (!MDN.webchat.iframeIsLoaded()) {
                        console.log("no iframe loaded, try to load");
                        MDN.webchat.loadWidgetIframe();
                    } else {
                        authenticateAndSendMessage();
                    }
                } else {
                    callback({ success: false, reason: "The widget is not loaded" });
                }
            };

        var contact = getRegisterContactPayload();
        var contactLabel = getRegisterContactLabelPayload();
        var topic = $("#contact-form-topic").find(":selected").text().trim();
        var subtopic = $("#contact-form-subtopic").find(":selected").text().trim();
        var contactMessage = contact.message || "";

        const message = `* **${contactLabel.firstName}**: ${contact.firstName} \n* **${contactLabel.lastName}**: ${contact.lastName} \n* **${contactLabel.mail}**: ${contact.mail} \n* **${contactLabel.orderNumber}**: ${contact.orderNumbers} \n* **${contactLabel.customerNumber}**: ${contact.customerNumber} \n* **${contactLabel.topic}**: ${topic} \n* **${contactLabel.subtopic}**: ${subtopic} \n* **${contactLabel.message}**: ${contactMessage}`;
        sendMessageToMondo(contact.mail, message, resolve);
        });
    }

    function areOrderNumbersRequired() {
        var currentTopic = $(".contact-form-container #contact-form-topic").val();
        return currentTopic === "cancellation" || currentTopic === "return";
    }

    function validInputs() {
        var isValid = true;

        $(".contact-form-container .form-control").each(function () {
            var isRequired = $(this).is('[required]');
            var inputType = $(this).prop('type');
            var inputId = $(this).prop('id');
            var isOrderNumber = $(this).hasClass("order-number-field")

            if (isRequired) {
                switch (inputType) {
                    case 'text':
                    case 'textarea':
                        isValid = checkTextInput($(this), isValid);
                        break;
                    case 'email':
                        isValid = checkEmailInput($(this),isValid);
                        break;
                    case 'checkbox':
                        isValid = checkBoxChecked($(this),isValid);
                        break;
                    case 'select-one':
                        isValid = checkSelected($(this),isValid);
                        break;
                }
            } else if (isOrderNumber) {
                 isValid = checkTextInput($(this), isValid);
            } else if (inputId && inputId === "contact-form-customer-number") {
                isValid = checkCustomerNumberTextInput($(this),isValid);
            }
        });

        return isValid;
    }

    function checkIfMondoIsLoaded() {
        return !!(typeof MDN !== 'undefined' && MDN && MDN.isLoaded() && MDN.webchat && MDN.webchat.isLoaded());
    }

    function checkBoxChecked(input, isValid) {
        if (input.is(':checked')) {
            input.siblings(".contact-form-input-error-div").hide();
            return isValid;
        } else {
            input.siblings(".contact-form-input-error-div").show();
            return false;
        }
    }

    function checkSelected(input, isValid) {
        if (input.val() !== null && input.val() !== "") {
            input.siblings(".contact-form-input-error-div").hide();
            return isValid;
        } else {
            input.siblings(".contact-form-input-error-div").show();
            return false;
        }
    }

    function checkCustomerNumberTextInput(input, isValid) {
        var isCustomerNumber = !input.val() || input.val().length <= 45;

        if (!isCustomerNumber) {
            input.siblings(".contact-form-input-error-div").show();
            return false;
        }

        input.siblings(".contact-form-input-error-div").hide();

        return isValid;
    }

    function checkTextInput(input, isValid) {
        var value = input.val().trim();

        if (input.hasClass("order-number-field")) {
            var errorDiv = input.parent().next();
            if (!areOrderNumbersRequired() && value === "") {
                        errorDiv.hide();
                        return isValid;
                    }

                    if (value.search(orderNumberRegex) > -1) {
                        errorDiv.hide();
                        return isValid;
                    } else {
                        errorDiv.show();
                        return false;
                }
        }

        if (value.length !== 0) {
            return isValid;
        } else {
            input.siblings(".contact-form-input-error-div").show();
            return false;
        }
    }

    function checkEmailInput(input, isValid) {
        var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (!regex.test(input.val())) {
            input.siblings(".contact-form-input-error-div").show();
            return false;
        } else {
            return isValid;
        }
    }

    function getOrderNumbers() {
        var orderNumbers = [];

        $(".contact-form-container .order-number-field").each(function () {
            orderNumbers.push($(this).val().trim());
        });

        return orderNumbers;
    }

    function getRegisterContactPayload() {
        var payload = {};

        var contactFormGender = $("#contact-form-gender");
        if (contactFormGender.parent().is(":visible")) {
            payload["gender"] = contactFormGender.find(":selected").val();
            payload["title"] = contactFormGender.find(":selected").text();
        }

        payload["firstName"] = $("#contact-form-first-name").val();
        payload["lastName"] = $("#contact-form-last-name").val();
        payload["mail"] = $("#contact-form-mail").val();
        payload["orderNumbers"] = getOrderNumbers();
        payload["customerNumber"] = $("#contact-form-customer-number").val();
        payload["subtopic"] = $("#contact-form-subtopic").find(":selected").attr('name');
        var messageValue = $("#contact-form-message").val();
        if (messageValue && messageValue.trim().length > 0) {
            payload["message"] = messageValue;
        }
        payload["termsCheckbox"] = !!$("#contact-form-checkbox").is(":checked");

        return payload;
    }

    function getRegisterContactLabelPayload() {
        var payload = {};

        payload["firstName"] = $("#contact-form-first-name").siblings('label').text().trim();
        payload["lastName"] = $("#contact-form-last-name").siblings('label').text().trim()
        payload["mail"] = $("#contact-form-mail").siblings('label').text().trim();
        payload["orderNumber"] = $('label[for="contact-form-order-number"]').text().trim();
        payload["customerNumber"] = $("#contact-form-customer-number").siblings('label').text().trim();
        payload["topic"] = $("#contact-form-topic").siblings('label').text().trim();
        payload["subtopic"] = $("#contact-form-subtopic").siblings('label').text().trim();
        payload["message"] = $("#contact-form-message").siblings('label').text().trim();

        return payload;
    }

    // Server-rendered message text, kept before the first rewrite so a later submit does not show a stale value
    function getOriginalText($message) {
        var originalText = $message.data("originalText");
        if (originalText === undefined) {
            originalText = $message.text();
            $message.data("originalText", originalText);
        }
        return originalText;
    }

    function showTicketMessage($message, ticket) {
        $message.text(getOriginalText($message).replace("{ticket}", ticket || "")).show();
    }

    function displayContactFormErrorMessage(data) {
        var parsedData = data;
        if (typeof data === "string") {
        try {
          parsedData = JSON.parse(data);
        } catch (e) {
          parsedData = data;
        }
        }

        var errorKey = parsedData;
        var messageParameters = {};

        if (parsedData && typeof parsedData === "object") {
            errorKey = parsedData.messageKey || parsedData.message || parsedData.responseMessage || parsedData.error || parsedData.code;
            messageParameters = parsedData.messageParameters || parsedData.parameters || {};
        }
        switch (errorKey) {
            case "cancel.order.error.left_warehouse_ticket_created":
                showTicketMessage($(".contact-form-error-left-warehouse"), messageParameters.ticket);
                break;
            case "cancel.order.error.already_cancelled":
                $(".contact-form-error-already-cancelled").show();
                break;
            case "cancel.order.error.mismatched":
                $(".contact-form-error-rdnr-mail-mismatch").show();
                break;
            case "cancel.order.error.cancellation_not_successful":
                $(".contact-form-error-cancellation-not-successful").show();
                break;
            case "rdnr.not.found":
                $(".contact-form-error-rdnr-not-found").show();
                break;
            case "request.already.sent":
                window.location.replace("/order/contact-form/success");
                break;
            case "rdnr.too.old.for.cancel":
                $(".contact-form-error-rdnr-too-old").show();
                break;
            case "rdnr.mail.not.match":
                $(".contact-form-error-rdnr-mail-mismatch").show();
                break;
            case "rdnr.mail.not.match.call.us":
                $(".contact-form-error-rdnr-mail-mismatch-call-us").show();
                break;
          case "cancel.order.ticket.created":
            showTicketMessage($(".contact-form-error-ticket-created"), messageParameters.ticket);
            break;
          case "cancel.order.ticket.already.created":
            showTicketMessage($(".contact-form-error-ticket-already-created"), messageParameters.ticket);
            break;
            default:
                var $defaultError = $(".contact-form-error-default");
                var defaultErrorText = getOriginalText($defaultError);
                var isPlainTextError = data && !(parsedData && typeof parsedData === "object");
                $defaultError.text(isPlainTextError ? data : defaultErrorText).show();
        }
    }

    function registerContact() {
        $(".contact-form-error-div").hide();
        $(".contact-form-success-div").hide();

        if (!validInputs()) {
            return;
        }

        var recaptchaResponse = ReifendirektCaptchaAddOnJs.getRecaptchaResponse('contactForm_recaptcha');

        var csrfToken = $("input[name='_csrf']").val();
        var $contactFormButton = $(".contact-form-container #contact-form-submit-button");
        $contactFormButton.attr("disabled", true);

        if ($("#isSendMessageToMondo").val() === "true" && checkIfMondoIsLoaded()) {
            $.ajax({
                url: "/order/contact-form/verify?g-recaptcha-response="+recaptchaResponse,
                type: "POST",
                contentType: "application/json; charset=utf-8",
                headers: {
                    "X-CSRF-TOKEN": csrfToken
                },
                data: JSON.stringify(getRegisterContactPayload())
            }).done(function () {
                sendDataToChatMondo().then((result) => {
                    if (result.success) {
                        window.location.replace("/order/contact-form/chat/success");
                    } else {
                        ajaxRegisterContact(recaptchaResponse);
                    }
                });
            }).fail(function (data) {
                displayContactFormErrorMessage(data.responseText);
                $contactFormButton.attr("disabled", false);
            })
        } else {
            ajaxRegisterContact(recaptchaResponse);
        }
    }

    function ajaxRegisterContact(recaptchaResponse) {
        var csrfToken = $("input[name='_csrf']").val();
        var topic = $("#contact-form-topic").val();
        $.ajax({
            url: "/order/register-contact?g-recaptcha-response="+recaptchaResponse,
            type: "POST",
            contentType: "application/json; charset=utf-8",
            headers: {
                "X-CSRF-TOKEN": csrfToken
            },
            data: JSON.stringify(getRegisterContactPayload())
        }).done(function () {
            if (topic === "cancellation") {
                window.location.replace("/order/contact-form/cancellation-success");
            } else {
                window.location.replace("/order/contact-form/success");
            }
        }).fail(function (data) {
            displayContactFormErrorMessage(data.responseText);
            var $contactFormButton = $(".contact-form-container #contact-form-submit-button");
            $contactFormButton.attr("disabled", false);
        })
    }

    function addOrderNumberInput(contactFormContainer) {
        if (orderNumberInputCounter === maxOrderNumberInputs) {
            return;
        }

        var wrapperDiv = $("<div>").addClass("contact-form-new-order-number-input-wrapper");
        var orderNumberControlContainer = $("<div>").addClass("order-number-control-container");

        var newOrderNumberInput = $("<input>")
            .addClass("form-control order-number-field")
            .attr("type", "text")
            .prop("required", areOrderNumbersRequired())

        var orderNumberInvalidText = contactFormContainer.find(".contact-form-order-number-error-div").first().text();
        var errorDiv = $("<div>")
            .addClass("contact-form-order-number-error-div")
            .text(orderNumberInvalidText);

        var removeInput = $("<input>")
            .addClass("contact-form-remove-order-number-input")
            .attr("value", "-")
            .attr("type", "button")
            .on('click', function () {
                orderNumberInputCounter--;
                wrapperDiv.remove();
            });

        orderNumberControlContainer.append(newOrderNumberInput);
        orderNumberControlContainer.append(removeInput);
        wrapperDiv.append(orderNumberControlContainer);
        wrapperDiv.append(errorDiv);

        contactFormContainer.find(".additional-order-numbers-container").first().append(wrapperDiv);
        orderNumberInputCounter++;
    }

    function changeSubtopic(contactFormContainer) {
        var orderNumberInputs = contactFormContainer.find(".order-number-field");
        var orderNumbersRequired = areOrderNumbersRequired();

        checkTextMessageRequired(contactFormContainer);
        orderNumberInputs.prop("required", orderNumbersRequired);
        contactFormContainer.find(".contact-form-order-number-error-div").hide();

        var orderNumberLabel = contactFormContainer.find(".contact-form-order-number-label").first();
        if (!orderNumberLabel.length) {
            return
        }

        if (orderNumbersRequired) {
            orderNumberLabel.addClass("required-field");
        } else {
            orderNumberLabel.removeClass("required-field")
        }
    }

    function checkTextMessageRequired(contactFormContainer) {
        var currentTopic = $("#contact-form-topic").val();
        var isMessageRequired = $("#contact-form-subtopic").find(":selected").data("message");
        var textMessageArea = contactFormContainer.find(".form-group #contact-form-message");

        if (currentTopic === "cancellation") {
            if (isMessageRequired === false) {
                textMessageArea.prop("required", false);
                textMessageArea.prev().removeClass("required-field");
                textMessageArea.parent().show();
            } else {
                textMessageArea.prop("required", true);
                textMessageArea.prev().addClass("required-field");
                textMessageArea.parent().show();
            }
        } else if (!isMessageRequired) {
            textMessageArea.prop("required", false);
            textMessageArea.val('');
            textMessageArea.prev().removeClass("required-field");
            textMessageArea.parent().hide();
        } else {
            textMessageArea.prop("required", true);
            textMessageArea.prev().addClass("required-field");
            textMessageArea.parent().show();
        }

    }

    function changeInput() {
        var input = $(this);
        if (input.attr('id') === 'contact-form-message') {
            return;
        }
        if (input.val().search(specialCharactersRegex) > -1) {
            if (input.val().search(specialCharactersRegex) > -1) {
                input.siblings('.contact-form-input-error-div').show()
            } else {
                input.siblings('.contact-form-input-error-div').hide();
            }
        }
    }

    function initialize() {
        var contactFormContainer = $(".contact-form-container").first();
        if (!contactFormContainer.length) {
            return;
        }

        contactFormContainer.find("#contact-form").on('submit', function (event) {
            event.preventDefault();
            if (ReifendirektCaptchaAddOnJs.isInvisibleCaptchaEnabled()) {
                ReifendirektCaptchaAddOnJs.executeRecaptcha('contactForm_recaptcha');
            } else{
               registerContact();
            }
        });

        contactFormContainer.find("#contact-form-first-name,#contact-form-last-name,#contact-form-mail,#contact-form-customer-number,#contact-form-message").on('change', changeInput);

        contactFormContainer.find("#add-order-number").on('click', function () {
            addOrderNumberInput(contactFormContainer);
        });

        contactFormContainer.find("#contact-form-topic").on('change', function () {
            if ($(this).data('options') === undefined) {
                $(this).data('options', $("#contact-form-subtopic option").clone());
            }

            $("#contact-form-subtopic").prop( "disabled", false);

            var id = $(this).val();
            var options = $(this).data('options').filter('[value=' + id + ']');
            
            // Hide no_reason option first (will be shown again if cancellation is selected)
            contactFormContainer.find("#contact-form-subtopic option[value='no_reason']").css("display", "none");

            if (id === "cancellation") {
                var noReasonOption = contactFormContainer.find("#contact-form-subtopic option[value='no_reason']").first();
                if (noReasonOption.length) {
                    noReasonOption.css("display", "block");
                    $("#contact-form-subtopic").html(noReasonOption.clone()).append(options);
                    $("#contact-form-subtopic").val("no_reason");
                } else {
                    var createdOption = $("<option>")
                        .attr("value", "no_reason")
                        .attr("name", "NO_REASON")
                        .attr("data-default", "true")
                        .attr("data-message", "false")
                        .prop("selected", true)
                        .text("No specific reason");
                    $("#contact-form-subtopic").html(createdOption).append(options);
                }
                changeSubtopic(contactFormContainer);
            } else {
                var emptyOption = $("<option>")
                    .attr("value", "")
                    .prop("selected", true)
                    .prop("disabled", true)
                    .text("");
                $("#contact-form-subtopic").html(emptyOption).append(options);
                contactFormContainer.find("#contact-form-subtopic").prop("disabled", false);
                changeSubtopic(contactFormContainer);
            }

            var input = $(this);
            if (input.val().search(specialCharactersRegex) > -1) {
                input.siblings('.contact-form-input-error-div').show()
            } else {
                input.siblings(".contact-form-input-error-div").hide();
                contactFormContainer.find("#contact-form-subtopic").siblings('.contact-form-input-error-div').hide();
            }
        });

        contactFormContainer.find("#contact-form-topic,#contact-form-subtopic").on('change', function () {
            changeSubtopic(contactFormContainer);
        });

        var initialTopic = contactFormContainer.find("#contact-form-topic").val();
        if (initialTopic === "cancellation") {
            var noReasonOption = contactFormContainer.find("#contact-form-subtopic option[value='no_reason']").first();
            if (noReasonOption.length) {
                noReasonOption.css("display", "block");
                contactFormContainer.find("#contact-form-subtopic").prop("disabled", false);
                contactFormContainer.find("#contact-form-subtopic").val("no_reason");
            }
        }

        if (initialTopic) {
            contactFormContainer.find("#contact-form-topic").trigger('change');
        }
        changeSubtopic(contactFormContainer);
    }

    return {
        initialize: initialize,
        registerContact: registerContact
    };

})($);

$(function () {
    ContactFormJs.initialize();
});
